/**
  * Custom component
  * This file has been created to recreate Binding Section
  * Keycloak Version: 25.0.6
  * Date: 18/10/2024
  */

import type { AppRouteObject } from "../routes";
import {BindingRoute} from "./routes/Binding";


const routes: AppRouteObject[] = [
  BindingRoute
];

export default routes;
